import { DropDownOption } from '@aibees/shared/components';
import type { TableFilterSelectOption } from './types';

export const useDropdownOptions = (
  options?: TableFilterSelectOption[]
): DropDownOption[] => {
  return (
    options?.map((option) => ({
      key: option.key ?? option.value,
      value: option.key ?? option.value,
      label: option.value,
      metadata: option.metadata?.toString(),
      startIcon: typeof option.icon === 'string' ? option.icon : undefined,
      startIconSx: option.iconSx,
    })) || []
  );
};
